import { KNN, Point3 } from "./KNN";

export class HeightDatumCache {
  private cacheByCrs: Map<string, KNN> = new Map<string, KNN>();
  private lastCrs: string = null;
  private last_x: number;
  private last_y: number;
  private resultCache: Array<[number, Point3]> = null;

  public hasInsertedPoints(crsWithVertical: string) {
    return !!this.cacheByCrs[crsWithVertical];
  }

  public insertPoints(crsWithVertical: string, points: Point3[]): void {
    this.cacheByCrs[crsWithVertical] = new KNN(points);
  }

  public query(
    crsWithVertical: string,
    x: number,
    y: number,
  ): number | undefined {
    const minPoints = 3;
    const maxPoints = 10;
    const maxDistance = 100;
    const invalidateDistance2 = 30 * 30;

    if (crsWithVertical == null) {
      return 0;
    }

    if (this.lastCrs == crsWithVertical && this.resultCache != null) {
      var lastdx = this.last_x - x;
      var lastdy = this.last_y - y;
      if (lastdx * lastdx + lastdy * lastdy <= invalidateDistance2) {
        // We're within the bounds of the cache. Try calculating off that.
        var weight = 0;
        var height = 0;
        var count = 0;
        this.resultCache.forEach((r) => {
          var dx = r[1][0] - x;
          var dy = r[1][1] - y;
          var d2 = dx * dx + dy * dy;
          if (d2 > maxDistance * maxDistance) return;
          var w = 1.0 / Math.max(d2, 1.0e-6);
          height += w * r[1][2];
          weight += w;
          ++count;
        });
        if (count >= minPoints) {
          // Enough points in the cache.
          return height / weight;
        }
      }
    }

    var knn = this.cacheByCrs[crsWithVertical];
    if (!knn) {
      return undefined;
    }

    // Find the closest points
    var result = knn.knnSearch(x, y, maxDistance, maxPoints);
    if (!result.length) {
      return undefined;
    }

    // Shepard interpolation.
    var weight = 0;
    var height = 0;
    var count = 0;
    result.forEach((r) => {
      var w = 1.0 / Math.max(r[0], 1e-6);
      height += w * r[1][2];
      weight += w;
      ++count;
    });

    if (count < minPoints) {
      return undefined;
    }

    this.lastCrs = crsWithVertical;
    this.last_x = x;
    this.last_y = y;
    this.resultCache = result;

    return height / weight;
  }
}
